module.exports = __webpack_public_path__ + "img/gaffertape_rood.880b8013.jpg";